import { useRef } from 'react';


export const useWheelAxisLock = () => {
    const lockAxisRef = useRef(null); // 'x' | 'y' | null

    const onWheel = (e) => {
        // Cho browser zoom
        if (e.ctrlKey || e.metaKey) return;

        const { deltaX, deltaY } = e;

        // Chưa khóa trục → xác định trục ưu tiên
        if (!lockAxisRef.current) {
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                lockAxisRef.current = 'x';
            } else {
                lockAxisRef.current = 'y';
            }
        }

        // Chặn trục còn lại
        if (lockAxisRef.current === 'x') {
            if (deltaY !== 0) e.preventDefault();
        } else if (lockAxisRef.current === 'y') {
            if (deltaX !== 0) e.preventDefault();
        }
    };

    const onWheelEnd = () => {
        lockAxisRef.current = null;
    };

    return { onWheel, onWheelEnd };
};
